import React from 'react';
import { Link } from 'react-router-dom';

import { Badge, Callout } from './shared';

const Platforms: React.FC = () => (
  <div>
    <h2 className="text-2xl font-bold mb-4">Jira, Trello &amp; Standalone</h2>
    <p className="text-sm text-base-content/70 mb-5 leading-relaxed">
      MFlow tracks work across three platforms. Pick whichever matches how your team already works — dashboard metrics,
      risk flags, and the AI assistant all work the same way once a project is connected, though not every metric
      applies to every platform (see the notes below).
    </p>

    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
      <div className="rounded-xl bg-base-200 shadow-card p-4 space-y-1.5">
        <Badge color="badge-info">Jira</Badge>
        <div className="font-semibold text-sm">Full metrics</div>
        <div className="text-xs text-base-content/60 leading-relaxed">
          Sync existing projects for the deepest analytics: PSI, cycle time, flow efficiency, per-user breakdowns, and
          risk flags. See <strong>Connect Jira</strong>.
        </div>
      </div>
      <div className="rounded-xl bg-base-200 shadow-card p-4 space-y-1.5">
        <Badge color="badge-info">Trello</Badge>
        <div className="font-semibold text-sm">Board metrics</div>
        <div className="text-xs text-base-content/60 leading-relaxed">
          Connect a board from <strong>Integrations</strong>. Trello has no fixed status taxonomy, so &quot;done&quot;
          is inferred from the last active list — sprint-relative and flow-efficiency metrics aren&apos;t available, but
          cycle time, reopen rate, and risk flags are. Click any card in the board&apos;s stats page for its full detail
          — labels, due date, description, comments, and a link back to the card in Trello.
        </div>
      </div>
      <div className="rounded-xl bg-base-200 shadow-card p-4 space-y-1.5">
        <Badge color="badge-success">Standalone</Badge>
        <div className="font-semibold text-sm">No setup, full metrics</div>
        <div className="text-xs text-base-content/60 leading-relaxed">
          MFlow&apos;s own Kanban tracker — custom statuses, labels, subtasks, comments, and its own PSI/throughput/
          bottleneck analytics. Nothing to connect; create a project from <strong>Standalone</strong> in the sidebar, or
          describe it to the <strong>Wizard</strong> and it&apos;s created for you. See{' '}
          <Link to="/docs/standalone" className="link link-primary">
            Standalone Projects
          </Link>{' '}
          for the full picture.
        </div>
      </div>
    </div>

    <Callout type="info">
      Every project — regardless of platform — shows up together in the project selector at the top of the dashboard and
      in the <strong>Chat</strong> session list, grouped by platform.
    </Callout>
  </div>
);

export default Platforms;
